// Custom BBQ grill icon — dome lid, grate, legs, heat wisps
export default function GrillIcon({ size = 26, className = "", strokeWidth = 1.8 }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Dome lid */}
      <path d="M5 14a11 11 0 0 1 22 0" />
      {/* Lid knob */}
      <circle cx="16" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
      {/* Body */}
      <path d="M4 14h24l-1.5 6a3 3 0 0 1-3 2H8.5a3 3 0 0 1-3-2L4 14z" />
      {/* Grate lines */}
      <path d="M9 17.5h14M9.5 19.5h13" opacity="0.7" />
      {/* Legs */}
      <path d="M9 22.5l-1.5 5M23 22.5l1.5 5" />
      {/* Heat wisps off the top */}
      <path d="M11 4c.6.8.6 1.5 0 2.3M16 2.5c.6.8.6 1.5 0 2.3M21 4c.6.8.6 1.5 0 2.3" opacity="0.55" />
    </svg>
  );
}
